import './customerCardStyle.scss';

import React, {Component} from 'react';

import {TatvamCol} from '../../functionalComponents';

class CustomerCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            valid_from: "",
            valid_upto: ""
        }
    }

    componentDidMount() {
        if (this.props.valid_from && this.props.valid_upto) {
            let dateFrom = new Date(this.props.valid_from).toDateString().replace('-', '').split(" ");
            let dateUpto = new Date(this.props.valid_upto).toDateString().replace('-', '').split(" ");
            let valid_from = dateFrom[2] + "-" + dateFrom[1] + "-" + dateFrom[3];
            let valid_upto = dateUpto[2] + "-" + dateUpto[1] + "-" + dateUpto[3];
            this.setState({
                valid_from: valid_from,
                valid_upto: valid_upto
            });
        }
    }

    onSelectionChanged() {
        if (this.props.edit) {
            this.props.edit([{id: this.props.id}]);
        }
    }

    render() {
        const defaultImage = "data:image/png;base64,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";
        return (

            <TatvamCol item s={6}>

                <TatvamCol s={12} onClick={this.onSelectionChanged.bind(this)}>

                    <div class="card customerCard">
                        <TatvamCol s={2}>
                            <div className="left d-flex image-uploaded mb-2 cardlayoutimage">
                                <img src={this.props.logo ? this.props.logo : defaultImage} alt="logo"
                                     title="Property Logo"/>
                            </div>
                        </TatvamCol>

                        <TatvamCol s={12} m={5}>
                            <div className="col s12">
                                <span className="property-label col s6"> Property ID : </span>
                                <span className="col s6">{this.props.id}</span>
                            </div>
                            <div className="col s12">
                                <span className="property-label col s6"> Name : </span>
                                <span className="col s6">{this.props.name}</span>
                            </div>
                            <div className="col s12">
                                <span className="property-label col s6"> Status : </span>
                                <span className="col s6">{this.props.status}</span>
                            </div>
                            {(this.props.category !== "Competitor" && this.props.category !== "Tenants") && (
                                <div className="col s12">
                                    <span className="property-label col s6">License from : </span>
                                    <span className="col s6 ">{this.props.valid_from}</span>
                                </div>
                            )}
                        </TatvamCol>
                        {/* <h6>
        <span class="customer_detail_label">Property ID :</span>{this.props.id}
        </h6>
        <h6>
        <span class="customer_detail_label">Name :</span>{this.props.name}
        </h6>
        <h6>
        <span class="customer_detail_label"> Status :</span> {this.props.status}
        </h6>
        {(this.props.category !== "Competitor" && this.props.category !== "Tenants") && (

        <h6><span class="customer_detail_label">License start date :</span>{this.state.valid_from}</h6>
        )} */}

                        <TatvamCol s={12} m={5}>

                            {(this.props.category !== "Competitor" && this.props.category !== "Tenants") && (
                                <div className="col s12">
                                    <span className="property-label col s8"> License Type : </span>
                                    <span className="col s4">{this.props.license}</span>
                                </div>
                            )}
                            <div className="col s12">
                                <span className="property-label col s8"> Industry : </span>
                                <span className="col s4">{this.props.industry}</span>
                            </div>

                            {(this.props.category !== "Competitor" && this.props.category !== "Tenants") && (
                                <div className="col s12">
                                    <span className="property-label col s8"> License upto : </span>
                                    <span className="col s4">{this.state.valid_upto}</span>
                                </div>
                            )}

                            <div className="col s12">
                                <span className="property-label col s8"> Execution Batch : </span>
                                <span className="col s4">{this.props.execution_batch}</span>
                            </div>
                        </TatvamCol>
                    </div>
                </TatvamCol>


            </TatvamCol>


        );
    }
}

export default CustomerCard;
